import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { GeneralService } from './services/general.service';
import { ConfigDataService } from './services/config-data.service';
import { TranslatorService } from './services/translator.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionTimerService } from './services/session-timer.service';
import { AuthenticationService } from './services/authentication.service';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

     @ViewChild('AreYouStillThereModal')
     AreYouStillThereModal: TemplateRef<any> | undefined;

     @ViewChild('NotProdModal')
     NotProdModal: TemplateRef<any> | undefined;

     @ViewChild('ShutDownModal')
     ShutDownModal: TemplateRef<any> | undefined;

     public isCollapsed = true;
     selectLang: string = 'EN';
     timeout: number = -1;
     timerObj: any = null;
     jwt: any = null;
     showSessionTimer: boolean = false;
     intervalObj: any = null;
     secondsRemaining: number = 60;
     version: string = '';
     err: any = null;
     currentMCMISUploadDateEN = '--';
     nextMCMISUploadDateEN = '--';
     currentMCMISUploadDateES = '--';
     nextMCMISUploadDateES = '--';
     currentMCMISUploadDateFR = '--';
     nextMCMISUploadDateFR = '--';
     selectedLang = "US English";
     searchPSPText = ""
     warnNonProdEnvironment: boolean = false;
     doRemount: boolean = false;
     isMenuCollapsed = true;
     warningHeader: string = "";
     warningText: string = "";
     nonProdModal: any;
     govShutdownModal: any;

     constructor(public translator: TranslatorService, public generalService: GeneralService,
          public configDataService: ConfigDataService, private router: Router,public sessionTimerService: SessionTimerService,
          public modalService: NgbModal,
          private authenticationService: AuthenticationService,
          @Inject(DOCUMENT) private document: Document,
          private cookieService: CookieService) {
          router.events.subscribe(event => {
               generalService.setRoute = router.url;
          });
     }

     ngOnInit() {
          this.generalService.setRoute = this.router.url;

          // Handle return from Login.gov
          let params = (new URL(document.location.href)).searchParams;
          const code = params.get("code");
          const state = params.get("state");
          if (code !== null && state != null) {
               // set a state in generalService that will tell the dashbaord to show a spinner
               this.generalService.setIsLoggingIn(code, state);
          }

          const hasAcknowledgedGovShutdown = this.cookieService.get('hasAcknowledgedGovShutdown');
          if (hasAcknowledgedGovShutdown !== undefined && hasAcknowledgedGovShutdown !== 'true') {
               this.configDataService.getGovShutdownInfo().then((info: string[]) => {
                    if (info[0].toString() === 'true') {
                         this.govShutdownModal = this.modalService.open(this.ShutDownModal, { ariaLabelledBy: 'shutDownModalTitle' });
                         this.warningHeader = info[1];
                         this.warningText = info[2];
                    }
               });
          }
     }

     ngAfterViewInit() {
          this.sessionTimerService.setModelRef(this.AreYouStillThereModal!);

          if (environment && (environment.NODE_ENV === 'qa' || environment.NODE_ENV === 'uat' || environment.NODE_ENV === '')) {
               const hasAcknowledged = this.cookieService.get('acknowledgedNonProd');
               if (!hasAcknowledged) {
                    this.warnNonProdEnvironment = true;
                    this.nonProdModal = this.modalService.open(this.NotProdModal, { ariaLabelledBy: 'notProdModalTitle' });
               }
          }
     }

     expandGov: boolean = false;
     get showExpandGov() {
          return this.expandGov;
     }

     get spanish() {
          return this.translator.getLanguagesRouteCanSee.includes("ES");
     }

     get french() {
          return this.translator.getLanguagesRouteCanSee.includes("FR");
     }

     get selectedLanguage() {
          return this.selectLang;
     }

     get homelink() {
          const userProfile = this.authenticationService.getUserProfile();
          if (!userProfile?.userData) {
               return '/';
          } else if (userProfile?.userData?.roles.includes('driver')) {
               return '/driverDashboard';
          } else if (userProfile?.userData?.roles.includes('mc_view')) {
               return '/dashboard';
          }
          return "/";
     }

     searchGov(event: any) {
          if (event === true || event.keyCode == 13) {
               var searchUrl = 'https://search.usa.gov/search?utf8=%E2%9C%93&affiliate=dot-fmcsa&query=' + encodeURIComponent(this.searchPSPText);
               window.open(searchUrl);
               event.preventDefault();
               return;
          }
     }

     setLanguage(lang: string) {
          this.selectedLang = (lang === "EN" ? "US English" :
               (lang === "ES" ? "Español" : "Français")
          );
          this.selectLang = lang;

          this.translator.setActiveLanguage(lang);
          this.document.documentElement.lang = lang.toLocaleLowerCase();
          const username = this.authenticationService.getUserName() || '';
          this.generalService.logActivity('language::update', username, [{ name: 'language', value: lang }], null);
     }

     //This will start the timer.
     get modalTitle() {
          return 'Are you still there?';
     }

     get modalText() {
          return '';
     }

     scrollToTop() {
          window.scrollTo(0, 0);
          return false;
     }

     extendSession() {
          this.sessionTimerService.clear();
          this.sessionTimerService.extendSession();
     }

     expandGovDetails() {
          this.expandGov = this.expandGov === false;
     }

     closeGovShutdownModal() {
          if (this.govShutdownModal) {
               this.govShutdownModal.close();
          }
          const date = new Date();
          date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day
          this.cookieService.set('hasAcknowledgedGovShutdown', 'true', date);
     }

     error(err: any) {
     }

     closeTestEnvModal() {
          this.warnNonProdEnvironment = false;
          if (this.nonProdModal) {
               this.nonProdModal.close();
          }

          const date = new Date();
          date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day
          this.cookieService.set('acknowledgedNonProd', 'true', date);
     }

     get routeSkipNav() {
          var skipNavURL = environment.BASE_URL + this.router.url
          var skipNavId = "#main-content";
          if (!this.router.url.includes(skipNavId)) {
               skipNavURL += skipNavId;
          }
          return skipNavURL;
     }

     get routeNavbar() {
          return this.router.url;
     }
}
